export const set = property => (state, payload) => (state[property] = payload)

export const toggle = property => state => (state[property] = !state[property])

export function injectScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.async = true
        script.src = src
        script.addEventListener('load', resolve)
        script.addEventListener('error', () => reject('Error loading script.'))
        script.addEventListener('abort', () => reject('Script loading aborted.'))
        document.body.appendChild(script)
    })
}

export function cleanNone(obj) {
    const result = {};
    Object.entries(obj).forEach(([key, value]) => {
        value === "None" ? result[key] = "" : result[key] = value
    });
    return result;
}